/* eslint-disable array-callback-return */
import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { snapshot, useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { uuid } from "uuidv4";
import {
    setGlobalDataIsUpdated,
    setIsModalOpened,
    store,
    setIsValidationNumToTake,
    setIsValidationPriceTheSpot,
    setIsValidationPriceToTake,
    setIsValidationPeriodToTake,
    setIsValidationNumDelivrey,
    setIsValidationNumTheSpot,
    setDuration,
    setKey,
    setIsAddCity,
    setIsAddZone,
    setIsAddCityAmount,
    setIsAddZoneAmount,
} from "../store";
import {
    store as device,
    setIsEdited,
    setActiveSubTab,
} from "../GeneralConfigC&C/City/store";
import {
    store as zoneStore,
    setIsEdited as setIsEditedZone,
} from "../GeneralConfigC&C/Zone/store";
import {
    store as cityAmountStore,
    setIsEdited as setIsEditedCityAmount,
} from "../GeneralConfigC&C/CityAmount/store";
import {
    store as zoneAmountStore,
    setIsEdited as setIsEditedZoneAmount,
} from "../GeneralConfigC&C/ZoneAmount/store";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { templateStore } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { clearFileStore, fileStore } from "../fileStore";
import "./index.css";
import {
    getApkTemplateDateModification,
    isClosed,
    postData,
    prepareSetupData,
    uploadApkTemplate,
    validateFormData,
    validateFormEmails,
} from "./hooks";
import { useSelector } from "react-redux";
import { useFetchGlobal } from "../../../../../api/hooks";
import { toast } from "react-toastify";
type PropsType = {
    children: React.ReactNode;
    title: string;
    selectedRows: any;
};
export function ModalWrapper({
    children,
    title = "",
    selectedRows,
}: PropsType): JSX.Element {
    const { oneShop, franchiseID } = useSnapshot(storeGlobal);
    const UPDATE_APK = selectedRows[0]?.Apk && !oneShop ? true : false;
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    let isShopClosed: boolean = false;
    const {
        isModalOpened,
        itemActivation,
        ItemSalesMethods,
        ItemPayementChoice,
        loyaltyAccount,
        options,
        orders,
        hourOfUse,
        isAddCity,
        isAddZone,
        isAddZoneAmount,
        isAddCityAmount,
        isErreur,
        overLaps,
        optionComposite,
        isValidationNumTheSpot,
        isValidationNumToTake,
        isValidationPriceTheSpot,
        isValidationPriceToTake,
        isValidationPeriodToTake,
        isValidationNumDelivrey,
        fuseau_horaire,
        iuudApk,
    } = useSnapshot(store);
    const { isEdited } = useSnapshot(device);
    const { isEdited: isEditedZone } = useSnapshot(zoneStore);
    const { isEdited: isEditedCityAmount } = useSnapshot(cityAmountStore);
    const { isEdited: isEditedZoneAmount } = useSnapshot(zoneAmountStore);
    const anyFormEdited =
        isEdited || isEditedZone || isEditedCityAmount || isEditedZoneAmount;
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [IsLoading, setIsLoading] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [modalKey, setModalKey] = React.useState(0);

    React.useEffect(() => {
        if (isModalOpened) {
            setIsEdited(false);
            setIsEditedZone(false);
            setIsEditedCityAmount(false);
            setIsEditedZoneAmount(false);
            setIsAddCity(false);
            setIsAddZone(false);
            setIsAddCityAmount(false);
            setIsAddZoneAmount(false);
            setActiveSubTab(0);
            setModalKey((prev) => prev + 1);
        }
    }, [isModalOpened]);

    isShopClosed = isClosed(hourOfUse);
    const reste = () => {
        clearFileStore();
        setIsModalOpened(!isModalOpened);
    };
    const resetValidations = () => {
        setIsValidationNumToTake(false);
        setIsValidationPriceTheSpot(false);
        setIsValidationPriceToTake(false);
        setIsValidationPeriodToTake(false);
        setIsValidationNumDelivrey(false);
        setIsValidationNumTheSpot(false);
        setDuration("");
        setIsAddCity(false);
        setIsAddZone(false);
        setIsAddCityAmount(false);
        setIsAddZoneAmount(false);
        setIsModalOpened(!isModalOpened);
    };

    const resetAllEdited = React.useCallback(() => {
        setIsEdited(false);
        setIsEditedZone(false);
        setIsEditedCityAmount(false);
        setIsEditedZoneAmount(false);
        setIsAddCity(false);
        setIsAddZone(false);
        setIsAddCityAmount(false);
        setIsAddZoneAmount(false);
    }, []);

    const restoreAllEdited = React.useCallback(
        (value: boolean) => {
            if (isEdited) setIsEdited(value);
            if (isEditedZone) setIsEditedZone(value);
            if (isEditedCityAmount) setIsEditedCityAmount(value);
            if (isEditedZoneAmount) setIsEditedZoneAmount(value);
        },
        [isEdited, isEditedZone, isEditedCityAmount, isEditedZoneAmount]
    );

    const toggle = () => {
        if (anyFormEdited) {
            setShowConfirmation(true);
        } else {
            resetValidations();
        }
    };

    async function ccSetup() {
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/setup/c&c`;
        const { savedData, isValidation } = await prepareSetupData({
            selectedRows,
            itemActivation,
            ItemSalesMethods,
            ItemPayementChoice,
            options,
            loyaltyAccount,
            hourOfUse,
            optionComposite,
            fuseau_horaire,
            orders,
            isValidationNumTheSpot,
            isValidationNumToTake,
            isValidationPriceTheSpot,
            isValidationPriceToTake,
            isValidationPeriodToTake,
            isValidationNumDelivrey,
            franchiseID,
        });
        if (isValidation) {
            setIsLoading(false);
        } else {
            await postData(apiUrlAdd, savedData, fetchGlobal, {
                onSuccess: () => {
                    resetValidations();
                    setKey(uuid());
                    setGlobalDataIsUpdated(true);
                },
                onError: () => {
                    setIsLoading(false);
                },
                onFinally: () => {
                    setIsLoading(false);
                },
            });
        }
    }

    async function handleSetup() {
        if (IsLoading) return;
        setIsLoading(true);

        try {
            const template: any = snapshot(templateStore);
            const formData = new FormData();
            const valid = await getApkTemplateDateModification(
                template,
                iuudApk,
                reste,
                fetchGlobal
            );
            if (!valid) return;

            formData.append(
                "globalTemplate",
                JSON.stringify(template.template)
            );

            Object.entries(fileStore).forEach(([key, file]) => {
                if (file instanceof File) {
                    formData.append(key, file);
                }
            });

            if (
                selectedRows[0].Boutique === "" &&
                !validateFormEmails(t, template)
            )
                return;

            let isValid = true;
            if (!UPDATE_APK) {
                isValid = await validateFormData(
                    t,
                    ItemSalesMethods,
                    ItemPayementChoice,
                    optionComposite,
                    isShopClosed,
                    orders,
                    overLaps,
                    isErreur,
                    ccSetup
                );
                if (!isValid) return;
            }

            const result = await uploadApkTemplate(
                iuudApk,
                formData,
                reste,
                fetchGlobal
            );
            if (!result) {
                throw new Error("Upload failed");
            }
        } catch (error) {
            setIsLoading(false);
            toast.error(`${"There's an error"}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setIsLoading(false);
        }
    }
    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                toggle={toggle}
                isOpen={isModalOpened}
                className="modal-wrapper__clz"
            >
                <ModalHeader
                    toggle={toggle}
                    className="text-uppercase modal-wrapper-title__clz"
                >
                    {title}
                </ModalHeader>
                <ModalBody className="p-0" key={modalKey}>
                    {children}
                </ModalBody>
                <ModalFooter>
                    {!isAddCity &&
                    !isAddZone &&
                    !isAddZoneAmount &&
                    !isAddCityAmount ? (
                        <CustomMainColorButton
                            className="w-20"
                            rounded
                            color={mainColor}
                            onClick={() => {
                                handleSetup();
                            }}
                        >
                            {t("Save")}
                        </CustomMainColorButton>
                    ) : (
                        <CustomMainColorButton className="style-buttom__clz" />
                    )}
                </ModalFooter>
            </Modal>
            {showConfirmation && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={showConfirmation}
                    setIsModalOpened={setShowConfirmation}
                    validationAction={() => setShowConfirmation(false)}
                    actions={() => {
                        resetAllEdited();
                        resetValidations();
                    }}
                    setIsEdited={restoreAllEdited}
                />
            )}
        </React.Fragment>
    );
}
